import React from "react";
import { useSearchParams } from "react-router-dom";
import { graphql } from "babel-plugin-relay/macro";
import { useMutation } from "relay-hooks";
import { EmailLinkTrackerMutation } from "./__generated__/EmailLinkTrackerMutation.graphql";

type Props = {};

const mutation = graphql`
  mutation EmailLinkTrackerMutation($newsletterId: String!, $unsubscribe: Boolean) {
    trackEmailLinkClick(newsletterId: $newsletterId, unsubscribe: $unsubscribe)
  }
`;

const EmailLinkTracker: React.FC<Props> = () => {
  const [searchParams] = useSearchParams();
  const newsletterId = searchParams.get("newsletterId");
  const unsubscribe = searchParams.get("unsubscribe");
  const done = React.useRef(false);
  const [trackClick] = useMutation<EmailLinkTrackerMutation>(mutation);

  React.useEffect(() => {
    if (newsletterId && !done.current) {
      done.current = true;
      trackClick({
        variables: {
          newsletterId,
          unsubscribe: !!unsubscribe
        }
      });
    }
  }, [newsletterId, unsubscribe, trackClick]);

  return null;
};

export default EmailLinkTracker;
